import { render, staticRenderFns } from "./ReturnDetailsContent.vue?vue&type=template&id=bcef4cd6&"
import script from "./ReturnDetailsContent.vue?vue&type=script&lang=js&"
export * from "./ReturnDetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDetailsContent.vue?vue&type=style&index=0&id=bcef4cd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports